<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div class="mask"
         key="1"
         @click="closeAlert"
         v-if="show"
         @touchmove.prevent>
    <div class="new-user"
         v-show="show"
         :style="swiperStyle">
        <div class="swiper-wrappper" :style="swiperBoxStyle" :class="bulletName">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in swiperData" :key='index'>
              <img :src="item">
            </swiper-slide>
            <div
              v-if="swiperData.length>1"
              class="swiper-pagination"
              slot="pagination"
            >
            </div>
          </swiper>
        <div class="openvip" @click.stop="openVip" :style="btnStyle"></div>
        <div v-if="isDownTime" class="down_time">00:{{minute}}:{{second}}后过期</div>
        <div v-if="playOpenVip" class="payVipButton" @click="handleClickVipButton"></div>
      </div>
      <img @click.stop="closeAlert"
           class="close"
           src="../adsense/static/close.png">
    </div>
  </div>
  </transition-group>
</template>
<script>
import { reportPay } from '@/libs/utils/log/log';
import store from '@/store';

export default {
  name: 'RaiseFocusMessage',
  data() {
    return {
      show: false,
      swiperOption: {
        pagination: { el: '.swiper-pagination' },
        preventLinksPropagation: false,
        watchOverflow: true,
        loop: true,
        autoplay: { disableOnInteraction: false },
      },
      swiperData: [],
      page_tp: '',
      swiperStyle: '',
      swiperBoxStyle: '',
      bulletName: '',
      isDownTime: false,
      minutes: 3,
      seconds: 0,
      close_down_time: 15,
      closeTime: {},
    };
  },
  computed: {
    second() {
      return this.num(this.seconds);
    },
    minute() {
      return this.num(this.minutes);
    },
  },
  methods: {
    openVip() {
      this.buyVipPlus();
      store.commit('SET_ORDER_LIST', true)
      reportPay({
        page_tp: this.page_tp,
        active_tp: 0, // 用户行为：0：点击 ;1：停留
        source: 0,
      });
    },
    closeAlert() {
      this.show = false;
      store.commit('SET_ORDER_LIST', true)
      if (this.closeCallback) {
        this.closeCallback();
      }
      window.clearInterval(this.closeTime);
    },
    num(n) {
      return n < 10 ? `0${n}` : `${n}`;
    },
    add() {
      const context = this;
      const time = window.setInterval(() => {
        if (context.seconds === 0 && context.minutes !== 0) {
          context.seconds = 59;
          context.minutes -= 1;
        } else if (context.minutes === 0 && context.seconds === 0) {
          context.seconds = 0;
          window.clearInterval(time);
        } else {
          context.seconds -= 1;
        }
      }, 1000);
    },
    handleClickVipButton() {
      this.event.$sendLog({
        event_type: 'click',
        event_name: '点击了解详情',
        event_data: {
          action: '点歌后弹窗第2首',
        },
      });
      this.event.$router.push('/thunder/openvip?fromType=ordernum2');
      this.playOpenVip = false;
      this.show = false;
      store.commit('SET_ORDER_LIST', true)
    },
  },
  mounted() {
    if (!store.state.intervalShowOrderList) {
      store.commit('SET_ORDER_LIST', false)
    }
    reportPay({
      page_tp: this.page_tp,
      active_tp: 3, // 用户行为：0：点击 ;1：停留
    });
    // 有倒计时
    if (this.isDownTime) {
      this.add();
    }
  },
};
</script>
<style lang="scss" scoped>
// 全局弹窗
.mask {
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  z-index: 101;
  width: 100%;
  height: 100%;
}
.new-user {
  position: absolute;
  width: 540px;
  height: 850px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -67.5px;
  background-image: url('https://qncweb-back1.ktvsky.com/20210607/vadd/17db655b455e16cb2ad63e753721d225.png');
  background-repeat:  no-repeat;
  background-size: 100% auto;
  background-position: center bottom;
  padding-top: 53vw;
}
 .bigScreen1 {
    ::v-deep .swiper-pagination-bullet {
       background: #2D46AA!important;
       &-active {
         background: #FFFFFF!important;
       }
     }
 }
  .bigScreen2 {
      .swiper-pagination {
          ::v-deep .swiper-pagination-bullet {
       background: #F8E37D!important;
       opacity:1!important;
       &-active {
         background: #B3371A!important;
        }
       }
      }
 }
.bigScreen3 {
    ::v-deep .swiper-pagination-bullet {
       background: rgba(255,255,255,0.50)!important;
       &-active {
         background: #FFFFFF!important;
       }
     }
 }
.bigScreen4 {
    ::v-deep .swiper-slide{
      width: 100%!important;
      padding:0!important;
    }
    ::v-deep .swiper-pagination-bullet {
       background: #a7a7a7!important;
       &-active {
         background: #D2D2D2!important;
       }
    }
     .openvip{
        width: 100%;
        height: 74px;
        margin: 35px auto 0;
    }
}
.bigScreen5 {
  .swiper-pagination {
    ::v-deep .swiper-pagination-bullet {
      background: #FFD87F!important;
      opacity:1!important;
      &-active {
        background: #8C5B00!important;
      }
    }
  }
}
.bigScreen6 {
  .swiper-pagination {
    ::v-deep .swiper-pagination-bullet {
      background: #B3371A!important;
      opacity:1!important;
      &-active {
        background: #F8E37D!important;
      }
    }
  }
}
.bigScreen7 {
  .swiper-pagination {
    ::v-deep .swiper-pagination-bullet {
      background: #F9A0A8!important;
      opacity:1!important;
      &-active {
        background: #F9F9F9!important;
      }
    }
  }
}
.bigScreen8 {
  .swiper-pagination {
    ::v-deep .swiper-pagination-bullet {
      background: #CBCEFF!important;
      opacity:1!important;
      &-active {
        background: #928DFD!important;
      }
    }
  }
}
.swiper-wrappper {
  width: 80%;
  margin: 0 auto;
  ::v-deep .swiper-slide{
      padding: 0px 20px;
  }
  .swiper-pagination {
    position: initial;
    ::v-deep .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #221010;
      margin: 0 6px;
      &-active {
        background: #3b1d1d;
      }
    }
  }
}
.openvip {
  width: 100%;
  height: 74px;
  margin: 65px auto 0;
}
.payVipButton {
  width: 100%;
  height: 60px;
}
.close {
  width: 54px;
  position: absolute;
  right: -20px;
  top: -74px;
}
.close_down_time {
  position: absolute;
  bottom: -192px;
  left: 50%;
  margin-left: -105px;
  width: 210px;
  height: 50px;
  background: rgba(255,255,255,0.20);
  border-radius: 25px;
  font-size: 24px;
  text-align: center;
  line-height: 50px;
  color: rgba(255,255,255,0.70);
}
.down_time {
  position: absolute;
  top: 38vw;
  left: 30vw;
  font-size: 26px;
  font-weight: 400;
  color: #940400;
}
</style>
